export function isNotDefined(value: any): value is null | undefined | void {
  return value === undefined || value === null;
}

export function isDefined<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function stringToBoolean(value: string): boolean {
  if (!isString(value)) throw new Error(`Value cannot be converted to Boolean: expected type is string, but the value is ${value}`);
  return value.trim().toLowerCase() === 'true';
}
